import { render, staticRenderFns } from "./FideicomisoLista.vue?vue&type=template&id=c2854e88"
import script from "./FideicomisoLista.vue?vue&type=script&lang=js"
export * from "./FideicomisoLista.vue?vue&type=script&lang=js"
import style0 from "./FideicomisoLista.vue?vue&type=style&index=0&id=c2854e88&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports